const qywxUtil = {}
const jsApiList =  ['scanQRCode'];

import { getSignNature } from '../../api/authorize'
import Vue from 'vue'

qywxUtil.isReady = false;
qywxUtil.init = async ()=>{
    return new Promise(async (res,rej)=>{
        if(qywxUtil.isReady){
            return;
        }

        let timestamp = Number.parseInt(Date.now()/1000);
        let nonceStr = '123';
        let resp  = null;
        try
        {
          resp = await getSignNature(nonceStr,timestamp, window.location.href.split('#')[0]);
        }
        catch(e){
            rej(e);
        }
        
        if(!resp || resp.code != 200 || !resp.data){
            rej('获取SignNature失败');
        }
        
        let signature = resp.data;

        wx.config({
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: Vue.prototype.$isDebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: Vue.prototype.$appId, // 必填，企业微信的corpID
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: jsApiList // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });

        wx.ready(function(data){
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            qywxUtil.isReady = true;    
            res('ok');    
        });
        
        wx.error(function(err){
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            qywxUtil.isReady = false;
            rej(err);
        });
    });
}

qywxUtil.scanQRCode = async ()=>{
    return new Promise(async (res,rej)=>{
        wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
         //   scanType: ["qrCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
            success: function(data) {
                res(data);
            },
            error: function(err) {
                alert(JSON.stringify(err))
                if (err.errMsg.indexOf('function_not_exist') > 0) {
                    alert('版本过低请升级')
                }
                rej(err);
            }
        });     
    });
}

export default qywxUtil